import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import moment from 'moment';

import {selectDate, createVideo, showModalFlag, showDetailFlag} from '../../actions';

import {Api,Time} from '../../util';
import Card from '../../components/card';
import {Video, Detail} from '../../components/modal';

// let ONAIR_TIMER;

class CardListContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      color: '',
      showModal: false,
      showDetail: false,
      modalInfo: {},
      currentOnAirCard: {
        index: -1,
        card: {}
      }
    };
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleContextMenuClick = this.handleContextMenuClick.bind(this);

    this.hadnleOnDetailClick = this.hadnleOnDetailClick.bind(this);
    this.handleDetailClose = this.handleDetailClose.bind(this);
  }
  
  handleContextMenuClick(options){
    const {data} = options;
    const videoNum = options.data.toLowerCase();
    const videoObj = {};
    videoObj[videoNum] = options;
    
    this.props.createVideo(videoObj);
   
  }
  async handleOnClick(info) {
    if(info.active){
      await this.setState({
        showModal: true,
        modalInfo: info
      });
      await this.props.showModalFlag(this.state.showModal);
    }

  }

  
  async handleModalClose(){
    await this.setState({showModal: false});
    await this.props.showModalFlag(this.state.showModal);
  }
  
  async hadnleOnDetailClick(){
    await this.setState({
      showDetail: true,
    });
    await this.props.showDetailFlag(this.state.showDetail);
  }
  
  async handleDetailClose(){
    await this.setState({showDetail: false});
    await this.props.showDetailFlag(this.state.showDetail);
  }

  
  render() {
    const {
      cardList,
      activeChannelListIndex,
      channelIndex,

      selectedMenu,
    } = this.props;
    const {
      showModal,
      modalInfo,
      currentOnAirCard,
      showDetail,

      color
    } = this.state;

    const cardListClasses = 'card-list ' + (activeChannelListIndex === channelIndex ? 'active' : '');
    
    
    return (
      <div className={cardListClasses}>
        {cardList.map((card, index) => {
          card.active = true;
          card.actor = undefined;
          card.airDate = card.date;
          card.category = undefined;
          card.chname = card.chName;
          // delete card.chName;
          card.desc = undefined;
          card.director = undefined;
          card.hls = undefined;
          card.epgid = card.chId + card.date + card.startTime;
          card.rating = undefined;
          card.title = (
            <Fragment>
              <div>{'방송시작 : ' + card.start.substr(8,2) + '시 ' + card.start.substr(10,2) + '분'}</div>
              <div>{'방송종료 : ' + card.stop.substr(8,2) + '시 ' + card.stop.substr(10,2) + '분'}</div>
            </Fragment>
          );

          card.use= 'Y';

          return <Card {...card} key={`card_${card.epgid}_${card.start}`}
            onContextMenuClick = {this.handleContextMenuClick}
            onDetailClick = {this.hadnleOnDetailClick}
            onClick={this.handleOnClick} />
        })}
        {showModal ? <Video 
          handleModalClose={this.handleModalClose}
          modalInfo={modalInfo}
        /> : null}
        {showDetail ? <Detail 
          handleDetailClose={this.handleDetailClose}
        /> : null}
      </div>
    );
  }
}

const mapDispatcherToProps = dispatch => {
  return {
    createVideo: (videoItem) => dispatch(createVideo(videoItem)),
    showModalFlag: (modalFlag) => dispatch(showModalFlag(modalFlag)),
    showDetailFlag: (detailFlag) => dispatch(showDetailFlag(detailFlag))
  }
};

const mapStateToProps = (state) => {
  return {
    selectedDate: state.selectedDate,
    videoItem: state.videoItem,
    chIndex: state.chIndex,
    activeChannelListIndex: state.activeChannelListIndex,
  }
};

CardListContainer = connect(mapStateToProps,mapDispatcherToProps)(CardListContainer);

export default CardListContainer;


// WEBPACK FOOTER //
// ./src/containers/file/CardListContainer.js